/*import './markup-menu';*/

import main from './components/main';
import map from './components/map';
import svg4everybody from 'svg4everybody';


document.addEventListener('DOMContentLoaded', () => {
  svg4everybody();
  main();
  if ($('#map').length > 0) {
    map();
  }
});



// WEBPACK FOOTER //
// app/scripts/index.js